<template>
  <div id="sign-up" >
    <div class="root">
      <div class="side-bar">
        <!-- <v-sheet style="background: #212338;" class="pa-10"> -->
          <div justify="start" class="d-flex flex-column">
              <div class="d-flex flex-row pt-md-4 pb-15">
                <img width="42" :src="require('../../assets/logos/logo-pict.svg')" />
                <h2 class="ml-2 reveles-text">
                  REVELES
                </h2>
              </div>
              <div class="pb-md-5">
                <span class="free-assessment"> FREE 30-DAY ASSESSMENT </span>
              </div>
          </div>
          <div>
            <p class="heading-text d-none d-md-flex">
              Get started with a free Reveles 30-day asset assessment
            </p>
          </div>
          <div class="d-none d-md-flex">
            <div class="price-text">
              $379/month after 30 days
            </div>
          </div>
          <div class="d-none d-md-flex">
            <p class="description-text">
                We'll analyze, segment and monitor your digital assests for 30 days to find patterns and tell your data dimension story.
            </p>
          </div>
          <div class="d-none d-md-flex flex-column">
            <div class="point-text">
              <div class="oval"></div>
              <div> Digital Asset Inventory </div>
            </div>
            <div class="point-text">
              <div class="oval"></div>
              <div> Digital Asset Segmentation </div>
            </div>
            <div class="point-text">
              <div class="oval"></div>
              <div> Retention Analysis </div>
            </div>
            <div class="point-text">
              <div class="oval"></div>
              <div> Unstructured Digital Assets </div>
            </div>
          </div>
        <!-- </v-sheet> -->
      </div>
      <div class="right-side-scroll">
        <div class="right-side">
          <div class="stepper">
            <div :class="step >= 1 ? 'fill' : 'circle' "></div>
            <div class="line-stepper" :style="{background: step > 1 ? '#3ACA56' :'#212338'}"></div>
            <div :class="step >= 2  ? 'fill' : 'circle' "></div>
            <div class="line-stepper" :style="{background: step > 2 ? '#3ACA56' :'#212338'}"></div>
            <div :class="step >= 3 ? 'fill' : 'circle' "></div>
          </div>
          <v-container class="pa-0">
            <v-row class="main-heading">
              <v-col col="12" lg="12" md="12" sm="12">
                <label v-if="step == 1" class="login-label">Create your account</label>
                <label v-if="step == 2" class="login-label">Set up a secure password.</label>
                <div v-if="step == 3" class="d-flex flex-column">
                  <label class="login-label">Provide your billing information.</label>
                  <label class="billing-description">Once the 30-days assessment is complete, <strong>$379/month</strong> will be charged to the card provided.</label>
                </div>
                <!-- <div class="line mt-5"></div> -->
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" lg="12" md="12" sm="12" class="py-0">
                <v-form v-if="step==1" ref="form" v-model="valid" class="justify-end" >
                  <div>
                    <v-text-field
                      label="Company Name"
                      v-model="userData.orgName"
                      required
                      :rules="[rules.required]"
                      validate-on-blur
                      class="mb-3"
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="userData.contact"
                      required
                      :rules="[rules.required]"
                      validate-on-blur
                      label="Primary Contact Name"
                      class="mb-3"
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="userData.email"
                      required
                      :rules="[rules.required, rules.email]"
                      validate-on-blur
                      :error-messages="emailError"
                      label="Primary Contact Email"
                      class="mb-3"
                      v-on:keyup="emailError=''"
                    >
                    </v-text-field>
                    <div class="d-flex flex-row justify-end">
                      <v-btn
                        :class="[ emailCheckLoading ? 'disabled-btn' : 'save-btn' , 'mt-4']"
                        style="width: 200px; background-color: #f4f7f9 !important;"
                        depressed
                        @click="validateForm()"
                        :disabled="emailCheckLoading"
                        tile
                      >
                        Next
                      </v-btn>
                    </div>
                  </div>
                </v-form>
                <v-form v-if="step==2" ref="form" v-model="valid" class="justify-end" >
                  <div>
                    <v-text-field
                      label="Password"
                      class="mb-1"
                      v-model="userData.password"
                      :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                      :rules="[rules.required]"
                      validate-on-blur
                      v-on:keyup="checkPassword(); matchPassword()"
                    >
                    </v-text-field>
                    <v-text-field
                      label="Confirm Password"
                      class="mb-1"
                      v-model="userData.confirmPassword"
                      :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                      validate-on-blur
                      :rules="[rules.required]"
                      v-on:keyup="matchPassword"
                    >
                    </v-text-field>
                    <div class="d-flex flex-wrap flex-md-row justify-space-between pt-10 pb-3">
                      <div class="password-check" :class="isLowercase ? 'fill-block' : ''">Lowercase</div>
                      <div class="password-check" :class="isUppercase ? 'fill-block' : ''">Uppercase</div>
                      <div class="password-check" :class="isNumber ? 'fill-block' : ''">Numbers</div>
                      <div class="password-check" :class="isSymbols ? 'fill-block' : ''">Symbols</div>
                      <div class="password-check" :class="isLength ? 'fill-block' : ''">8 Characters</div>
                      <div class="password-check" :class="isMatched ? 'fill-block' : ''">Matched</div>
                    </div>

                    <div v-if="showPasswordBreach || passwordReqSent" class="passowrd-exposed pb-4 align-center">
                      Has this password been previously exposed in data breaches?
                      <div v-if="passwordLoading" class="ml-5" data-title=".dot-pulse">
                          <div class="dot-pulse"></div>
                      </div>
                    </div>
                    <div v-if="!showPasswordBreach && passwordReqSent" class="passowrd-exposed-result">
                      <v-icon v-if="isPasswordSecure" class="ml-2" color="#212338">mdi-thumb-up</v-icon>
                      <v-icon v-else class="ml-2" color="#212338">mdi-thumb-down</v-icon>
                      <span class="ml-3"> {{isPasswordSecure ? 'No leaks found' : 'This password is not secure'}}  </span>
                    </div>

                    <div v-if="!showPasswordBreach && signupReqSent" class="passowrd-exposed pb-2 align-center">
                      Creating your account
                      <div v-if="checkError != 'account creation'">
                        <div v-if="signupLoading" class="ml-5" data-title=".dot-pulse">
                            <div class="dot-pulse"></div>
                        </div>
                        <img
                          class="ml-2"
                          v-else
                          :src="require('@/assets/icons/tick.svg')"
                        >
                      </div>
                    </div>
                    <div v-if="signinReqSent" class="passowrd-exposed pb-2 align-center">
                      Signing you in
                      <div v-if="checkError != 'signin'">
                        <div v-if="userLoading || signinLoading " class="ml-5" data-title=".dot-pulse">
                            <div class="dot-pulse"></div>
                        </div>
                        <img
                          class="ml-2"
                          v-else
                          :src="require('@/assets/icons/tick.svg')"
                        >
                      </div>
                    </div>
                    <div v-if="checkError" class="passowrd-exposed pb-2">
                      <img
                        class="ml-2"
                        :src="require('@/assets/icons/cross.svg')"
                      >
                      <span class="ml-2">An error occur during {{checkError}},</span>
                      <div class="ml-2">Click here to <strong  @click="continueSubmission" style="text-decoration: underline; cursor: pointer;">continue</strong></div>
                    </div>

                    <div class="d-flex flex-row justify-end">
                      <v-btn
                        :class="[ (signUpDisabled || !isPasswordCorrect) ? 'disabled-btn' : 'save-btn' , 'mt-14']"
                        style="width: 200px; background-color: #f4f7f9 !important"
                        depressed
                        @click="submit"
                        tile
                        :disabled="signUpDisabled || !isPasswordCorrect"
                      >
                        Next
                      </v-btn>
                    </div>
                  </div>
                </v-form>
                <v-form v-show="step==3" ref="form2" v-model="valid2" class="justify-end" >
                  <div>
                    <div class="login-label billing-address">BILLING ADDRESS</div>
                    <v-text-field
                      label="Street Address"
                      v-model="creditFormFields.address.line1"
                      :rules="[rules.required]"
                      validate-on-blur
                    >
                    </v-text-field>
                    <v-text-field
                      label="Phone"
                      v-model="creditFormFields.phone"
                      :rules="[rules.required]"
                      validate-on-blur
                    >
                    </v-text-field>
                    <v-row class="py-0">
                      <v-col cols="12" sm="12" md="8" lg="8" class="py-0">
                        <v-text-field
                          label="City"
                          v-model="creditFormFields.address.city"
                          :rules="[rules.required]"
                          validate-on-blur
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" class="py-0">
                        <v-select
                          label="State"
                          :items="states"
                          hide-details
                          v-model="creditFormFields.address.state"
                          :rules="[rules.required]"
                          @click:append="showPassword = !showPassword"
                          validate-on-blur
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row class="py-0">
                      <v-col cols="12" sm="12" md="8" lg="8" class="py-0">
                        <v-text-field
                          label="Zip Code"
                          v-model="creditFormFields.address.postal_code"
                          :rules="[rules.required]"
                          counter
                          hide-details
                          validate-on-blur
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" class="py-0">
                        <v-select
                          label="Country"
                          :items="countries"
                          item-text="name"
                          item-value="value"
                          v-model="creditFormFields.address.country"
                          :rules="[rules.required]"
                          counter
                          validate-on-blur
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <div class="login-label payment-info mt-10">PAYMENT INFO</div>
                    <div class="stripe-number mt-4">
                      <div id="card-number" class="pa-2 my-1"></div>
                      <!-- <div id="card-postal-code" class="pa-2 mx-2 my-1"></div> -->
                    </div>
                    <v-row class="stripe-div my-2 mt-4">
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <div id="card-expiry" class="expiry"></div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <div id="card-cvc" class="cvc"></div>
                      </v-col>
                    </v-row>
                    <div id="card-errors" role="alert" class="pa-2 ma-2"></div>
                    <div class="d-flex flex-row justify-end">
                      <v-btn
                        color="#4C86FD"
                        :class="[ addPaymentLoading ? 'disabled-btn' : 'save-btn' , 'mt-4']"
                        depressed
                        @click="addPayment"
                        style="width: 200px; background-color: #f4f7f9 !important"
                        tile
                        :disabled="addPaymentLoading"
                      >
                        Finish
                      </v-btn>
                    </div>
                  </div>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapMutations, mapGetters } from 'vuex'
import { validateName, validateEmail, validatePassword } from '@/utils/main_helper'
import { loadStripe } from '@stripe/stripe-js'
import { BANDS } from '@/utils/constants'
export default {
  name: 'SignUp',
  data () {
    return {
      card: '',
      cardNumber: '',
      stripe: '',
      stripeAPIToken: '',
      countries: [{ name: 'USA', value: 'US' }],
      states: ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District Of Columbia', 'Federated States Of Micronesia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
      creditFormFields: {
        name: '',
        phone: '',
        address: {
          line1: '',
          city: '',
          state: '',
          postal_code: '',
          line2: '',
          country: ''
        }
      },
      valid: false,
      valid2: false,
      userData: {},
      rules: {
        required: v => !!v || 'Required.',
        name: v => {
          if (!(v && v.length <= 100)) {
            return 'The field must be less than 100 characters'
          }

          if (!validateName(v)) {
            return 'Name must be valid'
          }

          return true
        },
        email: v => validateEmail(v) || 'E-mail must be valid',
        password: v => validatePassword(v) || 'Min. 8 characters with at least one capital letter, a number and a special character.'
      },
      status: 1,
      items: [{
        id: 0,
        text: 'Creating Account'
      }, {
        id: 1,
        text: 'Setting Up your Company'
      }, {
        id: 2,
        text: 'Signing You In'
      }],
      showPassword: false,
      signUpDisabled: false,
      checkError: '',
      step: 1,
      emailError: '',
      isLowercase: false,
      isUppercase: false,
      isNumber: false,
      isSymbols: false,
      isLength: false,
      isMatched: false,
      showPasswordBreach: false,
      signupReqSent: false,
      passwordReqSent: false,
      signinReqSent: false,
      isPasswordSecure: true,
      signupLoading: false,
      passwordLoading: false,
      addPaymentLoading: false,
      emailCheckLoading: false
    }
  },
  computed: {
    bands () {
      return BANDS
    },
    ...mapGetters({
      statusList: 'statusList',
      showStatusList: 'status'
    }),
    ...mapGetters(['currentOrganization', 'signinLoading', 'userLoading', 'paymentInformation', 'user', 'signinError']),
    statusListIds () {
      return this.statusList.map(s => s.id)
    },
    isPasswordCorrect () {
      return (this.isMatched && this.isLowercase && this.isUppercase && this.isSymbols && this.isNumber && this.isLength)
    },
    next1Disabled () {
      return !this.userData.orgName || !this.userData.email || !this.userData.contact
    },
    isInvalid () {
      return !this.creditFormFields.line1 || !this.creditFormFields.city || !this.creditFormFields.state
    },
    hasPaymentMethod () {
      if (this.paymentInformation) return !!(Object.keys(this.paymentInformation).length && this.paymentInformation.constructor === Object)
      else return false
    }
  },
  async mounted () {
    this.stripeAPIToken = process.env.VUE_APP_STRIPE_PUBLIC_TOKEN
    this.configureStripe()
    console.log(this.user)
    console.log('this.$auth')
    console.log(this.$auth)
    if (Object.keys(this.user).length && this.user.hasBillingInfo == false) {
      this.step = 3
    }
    if (Object.keys(this.user).length) {
      this.$store.dispatch('loadOrganizations')
    }
  },
  methods: {
    ...mapMutations({
      setStatusList: 'setStatusList',
      setStatus: 'setStatusOfList'
    }),
    async submit () {
      this.$refs.form.validate()
      if (!this.valid) return
      this.signUpDisabled = true
      this.userData.partner = 'customer'
      const store = this.$store
      const user = {
        ...this.userData,
        username: this.userData.email,
        role: 'owner'
      }
      this.showPasswordBreach = true
      this.passwordReqSent = true
      this.passwordLoading = true
      const that = this
      await this.$store.dispatch('checkPassword', this.userData.password)
        .then(async response => {
          this.showPasswordBreach = false
          this.passwordLoading = false
          if (response.data == 0) {
            that.isPasswordSecure = true
            that.signupReqSent = true
            that.signupLoading = true
            await this.$store.dispatch('signUpUserApi', user)
              .then((response) => {
                that.signupLoading = false
                const userData = response.data
                if (userData.error) {
                  context.commit('apiError', userData.error)
                  that.signupReqSent = false
                  that.signUpDisabled = false
                } else {
                  that.signinReqSent = true
                  store.dispatch('signInUserApi', user)
                }
              })
              .catch(error => {
                this.signupLoading = false
                this.showPasswordBreach = true
                this.signupReqSent = false
                this.checkError = 'account creation'
              })
          } else {
            that.isPasswordSecure = false
            that.signUpDisabled = false
          }
        })
        .catch(error => {
          this.passwordLoading = false
          this.checkError = 'password checking'
        })
    },
    checkPassword () {
      const password = this.userData.password
      var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
      if (password && password.length >= 8) this.isLength = true
      else this.isLength = false
      if (password && format.test(password)) this.isSymbols = true
      else this.isSymbols = false
      if (password && /\d/.test(password)) this.isNumber = true
      else this.isNumber = false
      if (password && /(?=.*[A-Z])/.test(password)) this.isUppercase = true
      else this.isUppercase = false
      if (password && /(?=.*[a-z])/.test(password)) this.isLowercase = true
      else this.isLowercase = false
    },
    matchPassword () {
      const password = this.userData.password
      const confirm = this.userData.confirmPassword
      if (password && confirm && password == confirm) this.isMatched = true
      else this.isMatched = false
    },
    async configureStripe () {
      this.stripe = await loadStripe(this.stripeAPIToken)
      this.elements = this.stripe.elements()
      const style = {
        base: {
          color: '#212338',
          fontFamily: 'Helvetica',
          fontSize: '18px',
          fontWeight: 'bold',
          '::placeholder': {
            color: '#212338',
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Helvetica'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
      // this.card = this.elements.create('card', { hidePostalCode: true, style: style })
      this.cardNumber = this.elements.create('cardNumber', { style: style, placeholder: 'Card Number' })
      this.cardNumber.mount('#card-number')
      var cardExpiry = this.elements.create('cardExpiry', { style: style, placeholder: 'Expiration Date' })
      cardExpiry.mount('#card-expiry')
      var cardCvc = this.elements.create('cardCvc', { style: style, placeholder: 'Security Code' })
      cardCvc.mount('#card-cvc')
      // var cardPostalCode = this.elements.create('postalCode', { style: style, placeholder: 'Zip Code' });
      // cardPostalCode.mount('#card-postal-code');

      // this.card.mount('#card-element')

      this.cardNumber.addEventListener('change', function (event) {
        const displayError = document.getElementById('card-errors')
        if (event.error) {
          displayError.textContent = event.error.message
        } else {
          displayError.textContent = ''
        }
      })
    },
    addPayment () {
      this.$refs.form2.validate()
      if (!this.valid2) return
      this.creditFormFields.name = this.userData.contact ? this.userData.contact : this.user.name
      const billingDetails = { ...this.creditFormFields }
      this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardNumber,
        billing_details: billingDetails
      }).then(async (result, _email) => {
        if (result.error) {
          const displayError = document.getElementById('card-errors')
          displayError.textContent = result.error.message
          // Show error in payment form
        } else {
          const payload = {
            payment_method_id: result.paymentMethod.id,
            name: this.creditFormFields.name,
            organization_id: this.currentOrganization.entity_id,
            typeMethod: 'post',
            subscription_plan: 'cloud_standard_monthly'
          }

          if (this.isInvalid) {
            payload.address = this.creditFormFields.address
          }

          if (!payload.organization_id) {
            await this.$store.dispatch('loadOrganizations')
            payload.organization_id = this.currentOrganization.entity_id
          }

          this.addPaymentLoading = true
          payload.organization_id && this.$store.dispatch('addPaymentMethod', payload).then((res) => {
            this.addPaymentLoading = false
            this.getBillingInfo(this.currentOrganization.entity_id)
            if (res) {
              const userData = this.user
              userData.hasBillingInfo = true
              this.$store.dispatch('updateProfile', { data: userData, shouldReload: false }).then(res => {
                this.$store.dispatch('setUser', userData)
                this.$router.push('/')
              })
            }
          }).catch(err => {
            this.addPaymentLoading = false
          })
        }
      })
    },
    getBillingInfo (entityId) {
      if (!entityId) return
      this.$store.dispatch('getBillingInfo', entityId)
    },
    async validateForm () {
      this.$refs.form.validate()
      if (!this.valid) return
      this.emailCheckLoading = true
      await this.validateEmail() && this.step++
      this.emailCheckLoading = false
    },
    continueSubmission () {
      if (this.checkError == 'password checking' || this.checkError == 'account creation') {
        this.submit()
      } else if (this.checkError == 'signin') {
        const user = {
          ...this.userData,
          username: this.userData.email
        }
        this.$store.dispatch('signInUserApi', user)
      }
      this.checkError = ''
    },
    async validateEmail () {
      const isValid = await this.$store.dispatch('validateUserEmail', { email: this.userData.email })
      if (isValid) {
        return true
      } else {
        this.emailError = 'An account with this e-mail already exists.'
        return false
      }
    }
  },
  watch: {
    user (user) {
      if (Object.keys(user).length) {
        this.$store.dispatch('loadOrganizations')
        this.step = 3
      }
    },
    currentOrganization (org) {
      if (org) {
        this.getBillingInfo('getBillingInfo', org.entity_id)
      }
    },
    signinError (value) {
      if (value) this.checkError = 'signin'
    }
  }
}
</script>

<style lang="scss">
  .v-main {
    padding-top: 0px !important;
  }
  .v-select__selections {
    color: #212338 !important;
    font-family: "gt_america_extendedBd";
    font-size: 18px !important;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: 500;
    margin-top: 2px;
  }
  .v-select__selection {
    margin-bottom: 0px;
  }
  .v-label--active {
    opacity: 0.4;
  }
  .primary--text {
    opacity: 1;
  }
  .v-text-field input {
    color: #212338 !important;
    font-family: "gt_america_extendedBd";
    font-size: 18px !important;
    letter-spacing: 0;
    line-height: 46px;
    font-weight: 500;
    padding-bottom: 0px;
  }
  .v-input__slot {
    padding: 0px 10px !important;
    align-items: flex-end;
  }
  .v-text-field__slot {
    padding-bottom: 5px;
  }
  .v-text-field label {
    color: #212338 !important;
    font-family: "gt_america_extended";
    font-size: 18px !important;
    letter-spacing: 0;
    line-height: 46px;
    font-weight: bold;
  }
</style>
<style lang="scss" scoped>
  .root {
    display: flex;
  }
  .side-bar {
    height: auto;
    top:0;
    bottom: 0;
    width: 530px !important;
    min-width: 530px;
    min-height: 100vh !important;
    padding-top: 100px !important;
    padding-left: 75px !important;
    padding-right: 75px !important;
    background: #212338;
    font-family: "gt_america_extended";
  }
  .reveles-text{
    font-weight: 900;
    font-size: 23px;
    line-height: 29px;
    color: #fff;
    font-family: 'gt_america_extended';
    padding: 10px 0px 0px 7px;
  }
  .free-assessment {
    height: 16px;
    width: 269px;
    color: #FFFFFF;
    font-family: "gt_america_extended";
    font-size: 14px;
    letter-spacing: 2.13px;
    line-height: 17px;
    font-weight: bold;
  }
  .heading-text{
    color: #FFFFFF;
    font-family: "gt_america_extendedBd";
    font-size: 39px;
    letter-spacing: 0;
    line-height: 46px;
    padding-bottom: 15px;
  }
  .description-text{
    height: 72px;
    width: 380px;
    color: #FFFFFF;
    font-family: "gt_america_extended";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: justify;
    margin-bottom: 30px;
  }
  .price-text {
    letter-spacing: 1.82px;
    line-height: 21.79px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    color: #212338;
    border-radius: 30px;
    padding: 20px 25px;
    background:#F4F7F9;
    margin-bottom: 40px;
    font-family: 'gt_america_extendedBd';
  }
  .point-text {
    color: #FFFFFF;
    font-family: "gt_america_extended";
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 10px;
  }
  .oval{
    height: 4px;
    width: 4px;
    background-color: #3ACA56;
    margin-right: 10px;
    border-radius: 4px;
  }
  .right-side-scroll {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 40px;
  }
  .right-side {
    margin: 0 auto;
    width: 580px !important;
    padding-top: 2rem;
  }
  .stepper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 70px;
  }
  .fill {
    height: 20px;
    width: 20px;
    background: #3ACA56;
    border-radius: 20px;
  }
  .circle {
    height: 20px;
    width: 20px;
    border-radius: 20px;
    border: 1px solid #212338;
    background: white;
  }
  .line-stepper {
    height: 1px;
    width: 120px;
    background: #212338;
  }
  .main-heading{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
  .login-label {
    color: #212338;
    font-family: "gt_america_extendedBd";
    font-size: 24px;
    letter-spacing: 0;
    line-height: 30px;
  }
  .login-btn {
    width: 120px;
  }
  .password-check {
    height: 30px;
    border-radius: 17.5px;
    color: #c8c8cA;
    font-family: "gt_america_extended";
    font-size: 11px;
    letter-spacing: 0;
    line-height: 18px;
    text-align: center;
    padding: 5px 15px;
    font-weight: bold;
    box-sizing: border-box;
    border: 1px solid #c8c8cA;
    border-radius: 17.5px;
    margin-left: 1px;
    opacity: 1 !important;
  }
  .fill-block{
    color: #fff;
    background-color: #212338;
    border: 1px solid #212338;
  }
  .passowrd-exposed {
    font-family: "gt_america_extended";
    color: #212338;
    padding-top: 20px;
    display: flex;
    flex-direction: row;
    align-content: center;
  }
  .passowrd-exposed-result {
    font-family: "gt_america_extendedBd";
    font-size: 12px;
    letter-spacing: 1.82px;
    line-height: 17px;
    text-transform: uppercase;
    color: #212338;
    padding: 5px;
    border-radius: 20px;
    background: rgba(58,202,86,0.16);
  }
  .billing-description {
    font-family: "gt_america_extended";
    padding-top: 15px;
  }
  .billing-address {
    font-family: "gt_america_extendedBd";
    font-size: 14px;
    padding-bottom: 25px;
    letter-spacing: 2.3px;
    line-height: 17px;
  }
  .payment-info {
    font-family: "gt_america_extendedBd";
    font-size: 14px;
    padding-bottom: 25px;
    letter-spacing: 2.3px;
    line-height: 17px;
  }
  .stripe-number {
    border-bottom: 1px solid #212338;
  }
  .stripe-div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .expiry {
    width: 100%;
    border-bottom: 1px solid #212338;
    padding: 10px;
  }
  .cvc {
    border-bottom: 1px solid #212338;
    width: 100%;
    padding: 10px;
  }
  // }
  .dot-pulse {
    position: relative;
    left: -9999px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #3ACA56;
    color: #3ACA56;
    box-shadow: 9999px 0 0 -5px #3ACA56;
    animation: dotPulse 1.5s infinite linear;
    animation-delay: .25s;
  }

  .dot-pulse::before, .dot-pulse::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #3ACA56;
    color: #3ACA56;
  }

  .dot-pulse::before {
    box-shadow: 9984px 0 0 -5px #3ACA56;
    animation: dotPulseBefore 1.5s infinite linear;
    animation-delay: 0s;
  }

  .dot-pulse::after {
    box-shadow: 10014px 0 0 -5px #3ACA56;
    animation: dotPulseAfter 1.5s infinite linear;
    animation-delay: .5s;
  }

  @keyframes dotPulseBefore {
    0% {
      box-shadow: 9984px 0 0 -5px #3ACA56;
    }
    30% {
      box-shadow: 9984px 0 0 2px #3ACA56;
    }
    60%,
    100% {
      box-shadow: 9984px 0 0 -5px #3ACA56;
    }
  }

  @keyframes dotPulse {
    0% {
      box-shadow: 9999px 0 0 -5px #3ACA56;
    }
    30% {
      box-shadow: 9999px 0 0 2px #3ACA56;
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 -5px #3ACA56;
    }
  }

  @keyframes dotPulseAfter {
    0% {
      box-shadow: 10014px 0 0 -5px #3ACA56;
    }
    30% {
      box-shadow: 10014px 0 0 2px #3ACA56;
    }
    60%,
    100% {
      box-shadow: 10014px 0 0 -5px #3ACA56;
    }
  }

@media only screen and (max-width: 1024px) {
  .side-bar {
    height: auto;
    top:0;
    bottom: 0;
    min-width: 430px;
    min-height: 100vh !important;
    padding-top: 100px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
    background: #212338;
    font-family: "gt_america_extended";
  }
  .right-side {
    margin: 0 auto;
    width: 580px !important;
    // padding-top: 2rem;
    padding: 0px 20px;
  }
  .right-side-scroll {
    justify-content: flex-start;
    padding-top: 200px;
  }
}

@media only screen and (max-width: 950px) {
  .root {
    flex-direction: column;
    width: 100%;
  }
  .side-bar {
    top:0;
    height: 200px !important;
    min-height: 200px !important;
    padding: 20px !important;
    width: 100% !important;
    min-width: 100% !important;
  }
  .right-side {
    margin: 0 auto;
    width: 100% !important;
    padding: 0px;
  }
  .right-side-scroll {
    width: 100% !important;
    margin: 0 auto;
    padding: 20px 10px 10px 10px;
  }
}
.password-check {
    margin-top: 5px;
}
.disabled-btn {
  background: #F4F7F9 !important;
  border-radius: 50px;
  width: 100%;
  text-transform: uppercase !important;
  letter-spacing: 1.97321px !important;
  color: $black-color !important;
  text-transform: uppercase;
  font-weight: bold !important;
  min-width: 198px !important;
  height: 50px !important;
  margin-bottom: 12px;
  opacity: 1 !important;
}

</style>
